class TicketDelegate {
    setTicketInitialState(ticketId) {
        this.setState({
            ticketId,
            user: this.data.user,
            ticket: null,
            ticketLoading: true,
            replyBody: '',
            replyAttachments: [],
            replySending: false,
            messagesLoadingMore: false
        });
    }

    setTicketLoading(loading) {
        this.setState({ ticketLoading: loading, messagesLoadingMore: false });
    }

    setTicketDetail(ticket, callback) {
        this.setState({ ticket, messagesLoadingMore: false }, callback);
    }

    setReplyBody(value) {
        this.setState({ replyBody: value });
    }

    setReplyAttachments(value) {
        this.setState({ replyAttachments: value });
    }

    setInvalidTicketState() {
        this.setState({ ticket: null, ticketLoading: false, messagesLoadingMore: false });
    }

    setMessagesloadingMore(loading) {
        this.setState({ messagesLoadingMore: loading });
    }

    setReplySending(value) {
        this.setState({ replySending: value });
    }
}

export default TicketDelegate;
